<div class="row">
  <div class="col-12 col-md-6">
    <form-row-input
      [label]="'qrcode-print.ean'"
      [required]="true"
      [(model)]="ean"
      (modelChange)="generateQR()"
      [inputDisabled]="isPrinting"
    ></form-row-input>
    <form-row-input
      [label]="'product.batch'"
      [(model)]="batch"
      (modelChange)="generateQR()"
      [inputDisabled]="isPrinting"
    ></form-row-input>
    <form-row-input
      [label]="'product.expirationDate'"
      [(model)]="expirationDate"
      (modelChange)="generateQR()"
      [inputDisabled]="isPrinting"
    ></form-row-input>
    @if (isInDesktopApp) {
      <form-row-input
        [inputType]="'number'"
        [label]="'qrcode.number-of-copies'"
        [(model)]="numberOfCopies"
        [inputDisabled]="isPrinting"
      ></form-row-input>
    }
    <div class="row mb-2">
      <div class="col">
        <btn
          [classes]="['btn-third']"
          [btnDisabled]="isPrinting"
          (onEvent)="printQR()"
          [label]="'print'"
          [title]="'print' | translate"
        ></btn>
      </div>
    </div>
    <div class="invisible">
      <canvas #qr id="qr"></canvas>
    </div>
  </div>
  <div class="col-12 col-md-6">
    <pre>{{ 'qrcode-print.code' | translate }}{{ finalCode }}</pre>
    <div class="barcode-array-container-margin" #printable id="printable">
      @if (qrBase64 && qrBase64.length > 0) {
        <img [src]="qrBase64" alt="" class="qr-code" />
      }
    </div>
  </div>
</div>
